function prediction_electricity(){
	var village_geojson = ajax_call("geojson/NTC_village.json"), 
		village_electricity_table = ajax_call("geojson/village_electricity_list.json"),
		wind_level_mapping = {"0": 0.1, "1": 0.9, "2": 2.45, "3": 4.4, "4": 6.7, "5": 9.35, "6": 12.3, "7": 15.5, "8": 18.95, "9": 22.6, "10": 26.45, "11": 30.55, "12": 34.8, "13": 39.2, "14": 43.8, "15": 48.55, "16": 53.5, "17": 58.650000000000006},
		wind_prediction_list
	$("#prediction_electricity").html(
		'<h5 class="font-weight-bold mb-0"><i class="fas fa-info-circle mr-2"></i>颱洪停電災情預測功能說明<button class="btn btn-sm btn-success float-right" type="button" id="prediction_electricity_list_updater">刷新預報</button></h5>'+
		'<h6 class="text-justify mt-1">為新北市消防局透過分析台灣電力公司相關電力資料以及歷史颱洪情資，所發展的人工智慧颱洪停電預測模型，最後透過氣象局風力預測資料，即可推估颱風事件下新北市各村里的停電風險以及中斷戶數等，而每一個預報可區分成三個時段進行預測。</h6>'+ //，另外也可任意輸入風力級數(平均風速、最大陣風)進行情境模擬。
		'<div class="input-group mt-2">'+
		  	'<div class="input-group-prepend">'+
		    	'<label class="input-group-text">選擇預報</label>'+
		  	'</div>'+
		  	'<select class="custom-select" id="prediction_electricity_selector"></select>'+
		'</div>'+
		'<button type="button" class="btn btn-success btn-sm btn-block mt-2 function-log" function-log-id="6" id="prediction_electricity_trig">查詢</button>'+
		'<div id="early_electricity_content" class="mt-2 pt-2 border-t-normal"></div>'
	);
	// 
	$("#prediction_electricity_list_updater").click(function(){
		wind_prediction_list = ajax_call(publicPath + "/napi/simulate/windcwbsimulation")
		console.log(wind_prediction_list)
		var wind_prediction_key_list = Object.keys(wind_prediction_list),
			list_option_html = '',
			now_list_target = $("#prediction_electricity_selector").val(),
			now_list_length = $("#prediction_electricity_selector option").length
		for (var i = wind_prediction_key_list.length - 1; i >= 0; i--) {
			if (wind_prediction_key_list[i] != " ") {
				var selected_option = ""
				if (wind_prediction_key_list[i] == now_list_target) { 
					selected_option = " selected"
				}
				list_option_html += '<option' + selected_option + ' value="' + wind_prediction_key_list[i] +'">' + wind_prediction_key_list[i] + '</option>'
			}
		}
		$("#prediction_electricity_selector").html(list_option_html)
		if (Object.keys(wind_prediction_list).length > now_list_length && now_list_length > 0) {
			toast_open("已有最新颱洪停電災情預測結果！")
		}
	}).click()
	// 
	$("#prediction_electricity_trig").click(function(){
		$("#map_clear").click();
		var report_target = $("#prediction_electricity_selector").val(),
			early_electricity_time_option_html = '<option value="0">No.1 未來0~6小時</option><option value="1">No.2 未來6~12小時</option><option value="2">No.3 未來12~18小時</option>',
			early_electricity_content_info_html = "",
			series_data_array = {
				"wind": [],
				"gust": [],
				"village": [],
				"household": [],
				"time": [],
				"end_time": [],
				"flag": []
			};
		if (wind_prediction_list[report_target]["dataset"].length == 0) {
			toast_open("此風力預報資訊範圍並無包含新北市！")
		} else {
			loader_asynchronous(function(){
				try {
					$("#early_electricity_content").html(
						'<h5 class="font-weight-bold mb-0"><i class="far fa-chart-bar mr-2"></i>停電預測趨勢數據統計<button type="button" class="btn btn-sm btn-link float-right" id="wind-level-definition-info-trig"><i class="fas fa-question mr-2"></i>風速級數定義</button></h5>'+
						'<div class="input-group mt-2">'+
							  '<div class="input-group-prepend">'+
								'<label class="input-group-text">檢視時間</label>'+
							  '</div>'+
							  '<select class="custom-select" id="prediction_electricity_time_report_selector">'+
							  '</select>'+
						'</div>'+
						'<div id="early_electricity_content_info" class="mt-3"></div>' +
						'<h5 class="font-weight-bold mb-0 mt-2 pt-2 border-t-normal"><i class="fas fa-table mr-2"></i>行政區村里斷電嚴重性統計與列表</h5>'+
						'<div class="h-300 w-100" id="electricity_region_early_chart"></div>' +
						'<table class="p-cursor" id="early_electricity_table" width="100%" height="100%">'+
							'<thead>'+
								'<tr>'+
									'<th rowspan="2">區域</th>'+
									'<th rowspan="2">村里</th>'+
									'<th rowspan="2">嚴重性預測</th>'+
									'<th class="text-center" colspan="3">影響統計</th>'+
								'</tr>'+
								'<tr>'+
									'<th>戶數</th>'+
									'<th>人數</th>'+
									'<th>脆弱點位數量</th>'+
								'</tr>'+
							'</thead>'+
							'<tbody>'+
							'</tbody>'+
						'</table>' +
						'<button type="button" class="btn btn-success btn-sm btn-block mt-2" id="prediction_electricity_table_download_trig">表單下載</button>' +
						'<hr>' +
						'<h5 class="font-weight-bold mb-0"><i class="far fa-chart-bar mr-2"></i>停電預測與風力預報結果</h5>'+
						'<div id="early_electricity_content_series" class="h-380 w-100"></div>'
					);
		
					wind_prediction_list[report_target]["dataset"].forEach(function(element, index){
						// 風力最大最小級數異常判斷與調整
						if (Number(element["wind"]["min"]) > Number(element["wind"]["max"])) {
							element["wind"] = {
								"min": Number(element["wind"]["max"]),
								"max": Number(element["wind"]["min"])
							}
						}
						if (Number(element["gust"]["min"]) > Number(element["gust"]["max"])) {
							element["gust"] = {
								"min": Number(element["gust"]["max"]),
								"max": Number(element["gust"]["min"])
							}
						}
						// 
						var active_tag
						if (index == 0) {
							active_tag = "active"
						} else {
							active_tag = ""
						}
						// 最強最弱預測結果異常判斷與調整
						element["min_pred"] = predict_eletricity_preprocessing(ajax_call(publicPath + "/cloud/edp2/power_failure/simulate?max_wind=" + wind_level_mapping[element["wind"]["min"]] + "&max_gust=" + wind_level_mapping[element["gust"]["min"]]));
						element["max_pred"] = predict_eletricity_preprocessing(ajax_call(publicPath + "/cloud/edp2/power_failure/simulate?max_wind=" + wind_level_mapping[element["wind"]["max"]] + "&max_gust=" + wind_level_mapping[element["gust"]["max"]]));
						element["min_pred"] = predict_eletricity_sta(element["min_pred"]);
						element["max_pred"] = predict_eletricity_sta(element["max_pred"]);
						if (parseInt(element["max_pred"]["household_number"]) < parseInt(element["min_pred"]["household_number"])) {
							var temp_var = element["max_pred"]
							element["max_pred"] = element["min_pred"]
							element["min_pred"] = temp_var
						}
						// 
						early_electricity_content_info_html +=
							'<div class="carousel-item ' + active_tag +'">' +
								'<h4 class="mb-3">No.' + (index+1) + " " + element["start_time"] +'預測結果</h4>' +
								'<div class="row">' +
									'<div class="col-6 mb-2">' +
										'<h5 class="mb-2 pb-2 border-b-normal"><i class="fas fa-wind mr-2"></i>平均風速 (級)</h5>' +
										'<div class="row">' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-success">最小預測</span></h5>' +
												'<h3>' + element["wind"]["min"] +'</h3>'+
											'</div>' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-danger">最大預測</span></h5>' +
												'<h3>' + element["wind"]["max"] +'</h3>'+
											'</div>' +
										'</div>' +
									'</div>' +
									'<div class="col-6 mb-2">' +
										'<h5 class="mb-2 pb-2 border-b-normal"><i class="fas fa-map-marker-alt mr-2"></i>中斷村里數 (處)</h5>' +
										'<div class="row">' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-success">最小預測</span></h5>' +
												'<h3>' + element["min_pred"]["village_number"] +'</h3>'+
											'</div>' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-danger">最大預測</span></h5>' +
												'<h3>' + element["max_pred"]["village_number"] +'</h3>'+
											'</div>' +
										'</div>' +
									'</div>' +
									'<div class="col-6">' +
										'<h5 class="mb-2 pb-2 border-b-normal"><i class="fas fa-wind mr-2"></i>最大陣風 (級)</h5>' +
										'<div class="row">' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-success">最小預測</span></h5>' +
												'<h3>' + element["gust"]["min"] +'</h3>'+
											'</div>' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-danger">最大預測</span></h5>' +
												'<h3>' + element["gust"]["max"] +'</h3>'+
											'</div>' +
										'</div>' +
									'</div>' +
									'<div class="col-6">' +
										'<h5 class="mb-2 pb-2 border-b-normal"><i class="fas fa-male mr-2"></i>中斷總戶數 (戶)</h5>' +
										'<div class="row">' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-success">最小預測</span></h5>' +
												'<h3>' + element["min_pred"]["household_number"] +'</h3>'+
											'</div>' +
											'<div class="col-6">' +
												'<h5><span class="badge badge-danger">最大預測</span></h5>' +
												'<h3>' + element["max_pred"]["household_number"] +'</h3>'+
											'</div>' +
										'</div>' +
									'</div>' +
									'<div class="col-12">' +
										'<h6 class="float-right">有效時間：' + element["start_time"] + "~" + element["end_time"] + '</h6>'+
									'</div>' +
								'</div>' +
							'</div>';
						series_data_array["time"].push(element["start_time"].slice(5,16));
						series_data_array["end_time"].push(element["end_time"].slice(5,16));
						var this_time_value = time_sql_processing(element["start_time"]);
						series_data_array["wind"].push([this_time_value, Number(element["wind"]["max"])]);
						series_data_array["gust"].push([this_time_value, Number(element["gust"]["max"])]);
						series_data_array["village"].push([this_time_value, element["max_pred"]["village_number"]]);
						series_data_array["flag"].push({
							x: this_time_value,
							title: "No." + (index+1),
							text: "預測電力中斷戶數達" + element["max_pred"]["household_number"] + "戶"
						});
					});
		
					$("#prediction_electricity_time_report_selector").html(early_electricity_time_option_html);
		
					$("#early_electricity_content_info").html(
						'<div id="carouselExampleIndicators" class="carousel slide html-carousel" data-ride="carousel">'+
							'<ol class="carousel-indicators d-none">'+
								'<li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>'+
								'<li data-target="#carouselExampleIndicators" data-slide-to="1"></li>'+
								'<li data-target="#carouselExampleIndicators" data-slide-to="2"></li>'+
							'</ol>'+
							'<div class="carousel-inner">'+
								early_electricity_content_info_html + 
							'</div>'+
						'</div>'
					);
		
					Highcharts.stockChart('early_electricity_content_series', {
						chart: {
							zoomType: 'xy'
						},
						title: {
							text: series_data_array["time"][0] + "~" + series_data_array["end_time"][2] + '停電趨勢',
							align: 'center'
						},
						navigator: {
							enabled: false
						},
						scrollbar: {
							enabled: false
						},
						rangeSelector : {
							enabled: false
						},
					   //  xAxis: [{
					   //      categories: series_data_array["time"],
					   //      crosshair: true,
					   //      labels:{
						  //       useHTML:true,
								// formatter:function(){
					//                	return this.value.slice(0,5) + "<br>" + this.value.slice(6,11);
					//             }
					   //      }
					   //  }],
						yAxis: [{
							allowDecimals: false,
							opposite: true,
							labels: {
								format: '{value}',
								style: {
									color: '#dc3545'
								}
							},
							title: {
								text: '電力中斷村里數',
								style: {
									color: '#dc3545'
								}
							}
						}, {
							allowDecimals: false,
							gridLineWidth: 1,
							title: {
								text: '風速(級)'
							},
							labels: {
								format: '{value}'
							}
						}],
						tooltip: {
							shared: true
						},
						legend: {
							enabled: true,
							layout: 'vertical',
							align: 'left',
							verticalAlign: 'top',
							floating: true,
							backgroundColor:
								Highcharts.defaultOptions.legend.backgroundColor || // theme
								'rgba(255,255,255,0.25)'
						},
						plotOptions: {
							series: {
								cursor: 'pointer',
								point: {
									events: {
										click: function () {
											var this_index = this.index;
											$("#prediction_electricity_time_report_selector").find("option").eq(this_index).attr("selected", true);
											$("#early_electricity_content_info li").eq(this_index).click();
											electricity_map_table_render(wind_prediction_list[report_target]["dataset"][this_index], report_target);
										}
									}
								}
							}
						},
						series: [{
							name: '平均風速',
							type: 'column',
							yAxis: 1,
							data: series_data_array["wind"],
							tooltip: {
								valueSuffix: ' 級'
							},
							id: 'wind_series'
						}, {
							name: '最大陣風',
							type: 'column',
							yAxis: 1,
							color: '#0080ff',
							data: series_data_array["gust"],
							marker: {
								enabled: false
							},
							dashStyle: 'shortdot',
							tooltip: {
								valueSuffix: ' 級'
							}
						}, {
							name: '中斷村里數',
							type: 'spline',
							color: '#dc3545',
							data: series_data_array["village"],
							tooltip: {
								valueSuffix: ' 處'
							},
							marker: {
								enabled: true,
								radius: 6
							}
						}, {
							type: "flags",
							showInLegend: false,
							data: series_data_array["flag"],
							width: 28,
							shape: 'squarepin',
							yAxis: 1,
							onSeries: 'wind_series',
							plotOptions: {
								line: {
									dataLabels: {
										enabled: true
									}
								}
							},
						}],
						responsive: {
							rules: [{
								condition: {
									maxWidth: 500
								},
								chartOptions: {
									legend: {
										floating: false,
										layout: 'horizontal',
										align: 'center',
										verticalAlign: 'bottom',
										x: 0,
										y: 0
									}
								}
							}]
						}
					});
					electricity_map_table_render(wind_prediction_list[report_target]["dataset"][0], report_target);
					$("#prediction_electricity_time_report_selector").change(function(){
						var target = $(this).val();
						$("#early_electricity_content_info li").eq(target).click();
						electricity_map_table_render(wind_prediction_list[report_target]["dataset"][target], report_target);
					});
		
					$("#prediction_electricity_table_download_trig").click(function(){
						var all_result_array = [], introduction_array = [["預報數", "開始時間", "結束時間"]];
						for (var i = 0; i < 3; i++) {
							var this_report_value = electricity_table_download(wind_prediction_list[report_target]["dataset"][i], report_target);
							this_report_value.unshift(["行政區", "村里", "嚴重性預測", "村里戶數", "村里人數", "脆弱點位數量"]);
							all_result_array.push(this_report_value);
							introduction_array.push(["No." + (i+1) , wind_prediction_list[report_target]["dataset"][i]["start_time"], wind_prediction_list[report_target]["dataset"][i]["end_time"]])
						};
						all_result_array.unshift(introduction_array);
						downloadxlsx("停電預測表單_" + report_target + ".xlsx", ["說明", "No.1 未來0~6時", "No.2 未來6~12時", "No.3 未來12~18時"], all_result_array);
					});
	
					$("#wind-level-definition-info-trig").click(function(){
						var html = ""
						Object.keys(wind_level_mapping).forEach(el => {
							html += `
								<tr>
									<td>${el}級</td>
									<td>${wind_level_mapping[el].toFixed(2)} m/s</td>
								</tr>`
						})
						modal_open(`
							<table class="table table-sm table-bordered">
								<thead class="thead-dark">
									<tr>
										<th>級數</th>
										<th>風速</th>
									</tr>
								</thead>
								<tbody>
									${html}
								</tbody>
							</table>`,
							"風速級數定義"
						)
					})
				} catch (e) {
					toast_open("AI模式計算API發生異常。")
				}
			});
		}
	});

	function predict_eletricity_preprocessing(object){
		for (var each in object["predict"]) {
			if (object["predict"][each].cat == 0) {
				delete object["predict"][each]; 
			}
		}
		return object;
	}

	function predict_eletricity_sta(object){
		var total_households = 0;
		object["village_number"] = Object.keys(object["predict"]).length;
		if (object["village_number"] != 0) {
			for (var each in object["predict"]) {
				total_households += village_electricity_table[each].household_no;
			}
		}
		object["household_number"] = total_households;
		return object;
	}

	function electricity_table_download(object, report_target_name){
		var target_list = Object.keys(object["max_pred"]["predict"]), tbody_data_array = [], region_sta_container = {};
		village_geojson.features.forEach(function(element){
			var new_vill_code = element.properties.VILLCODE.slice(0,3) + element.properties.VILLCODE.slice(5,8) + "0-" + element.properties.VILLCODE.slice(-3);
			var boolean_condition = (target_list.indexOf(new_vill_code) != -1);
			if (boolean_condition) {
				element.properties.bool = object["max_pred"]["predict"][new_vill_code].bool;
				element.properties.cat = object["max_pred"]["predict"][new_vill_code].cat;
				if(region_sta_container[element.properties.TOWNNAME] == undefined){
					region_sta_container[element.properties.TOWNNAME] = {
						"cat1": 0, "cat2": 0, "cat3": 0, "cat4": 0, "sum": 0
					};
				};
				region_sta_container[element.properties.TOWNNAME]["cat" + element.properties.cat] += 1;
				region_sta_container[element.properties.TOWNNAME]["sum"] += 1;
				tbody_data_array.push([element.properties.TOWNNAME, element.properties.VILLNAME, electricity_cat_mapping(object["max_pred"]["predict"][new_vill_code].cat).string, village_electricity_table[new_vill_code].household_no, village_electricity_table[new_vill_code].people_total, element.properties.fragile_count]);
			};
		});
		return tbody_data_array;
	}

	function electricity_map_table_render(object, report_target_name){
		var geojson = {type: "FeatureCollection", features: []}, region_sta_container = {};
		if (overlay_dataset["electricity_layer"] != undefined) { map.removeLayer(overlay_dataset["electricity_layer"])};
		var target_list = Object.keys(object["max_pred"]["predict"]), tbody_data_array = [];
		village_geojson.features.forEach(function(element){
			var new_vill_code = element.properties.VILLCODE.slice(0,3) + element.properties.VILLCODE.slice(5,8) + "0-" + element.properties.VILLCODE.slice(-3);
			var boolean_condition = (target_list.indexOf(new_vill_code) != -1);
			if (boolean_condition) {
				element.properties.bool = object["max_pred"]["predict"][new_vill_code].bool;
				element.properties.cat = object["max_pred"]["predict"][new_vill_code].cat;
				geojson.features.push(element);
				if(region_sta_container[element.properties.TOWNNAME] == undefined){
					region_sta_container[element.properties.TOWNNAME] = {
						"cat1": 0, "cat2": 0, "cat3": 0, "cat4": 0, "sum": 0
					};
				};
				region_sta_container[element.properties.TOWNNAME]["cat" + element.properties.cat] += 1;
				region_sta_container[element.properties.TOWNNAME]["sum"] += 1;
				tbody_data_array.push([element.properties.TOWNNAME, element.properties.VILLNAME, electricity_cat_mapping(object["max_pred"]["predict"][new_vill_code].cat).string, village_electricity_table[new_vill_code].household_no, village_electricity_table[new_vill_code].people_total, element.properties.fragile_count]);
			};
		});
		$('#early_electricity_table').DataTable().destroy();
        $('#early_electricity_table').DataTable({
            "data": tbody_data_array,
            "deferRender": true,
            "order": [[ 2, "asc" ], [ 5, "desc" ]],
            "searching": true
        });

        $("#early_electricity_table tbody").on("click", "tr", function(){
        	var full_vill_name = $(this).find("td").eq(0).html() + $(this).find("td").eq(1).html();
            geojson.features.forEach(function(element){
            	var this_feature_full_vill_name = element.properties.TOWNNAME + element.properties.VILLNAME;
            	if (full_vill_name == this_feature_full_vill_name) {
            		var this_feature = L.geoJson(element);
            		map.fitBounds(this_feature.getBounds());
            	};
            })
        });

		overlay_dataset["electricity_layer"] = L.geoJson(geojson, {
			style: function(feature){
				var fill_color = "";
				switch(feature.properties.cat){
					case 1:
						fill_color = "#FED976"
						break;
					case 2:
						fill_color = "#FD8D3C"
						break;
					case 3:
						fill_color = "#FC4E2A"
						break;
					case 4:
						fill_color = "#E31A1C"
						break;	
				}
			    return {
			        fillColor: fill_color,
			        weight: 2,
			        opacity: 1,
			        color: 'white',
			        dashArray: '3',
			        fillOpacity: 0.5
			    };
			}
		}).addTo(map);
		overlay_dataset["electricity_layer"].on('click', electricity_layer_click);
		function electricity_layer_click(e){
			var predict_table_html_string = {
					"report_number": "", "time": "", "wind": "", "impact": ""
				},
				predict_table_column_color = [],
				this_geojson_data = e.layer.toGeoJSON(),
				this_marker = e.layer.feature.properties,
				new_vill_code = this_marker.VILLCODE.slice(0,3) + this_marker.VILLCODE.slice(5,8) + "0-" + this_marker.VILLCODE.slice(-3),
				this_village_electricity_table = village_electricity_table[new_vill_code]
			wind_prediction_list[report_target_name]["dataset"].forEach(function(element, index){
				predict_table_html_string["time"] += '<td class="electricity_layer_table_colum' + (index+1) + '" scope="col">' + element.start_time + '~<br>' + element.end_time +'</td>';
				predict_table_html_string["wind"] += 
					'<td class="electricity_layer_table_colum' + (index+1) + '" scope="col">' +
						'平均陣風：' + element.wind.min + "~" + element.wind.max + '級<br>' +
						'最大陣風：' + element.gust.min + "~" + element.gust.max + '級' +
					'</td>';
				var this_vill_result_max = element["max_pred"]["predict"][new_vill_code];
				var this_vill_result_min = element["min_pred"]["predict"][new_vill_code];
				switch(true){
					case(this_vill_result_min == undefined && this_vill_result_max == undefined):
						predict_table_html_string["impact"] += '<td class="electricity_layer_table_colum' + (index+1) + '" scope="col" class="vertical-mid">「不會發生」</td>';
						break;
					case(this_vill_result_min != undefined && this_vill_result_max == undefined):
						predict_table_html_string["impact"] += '<td class="electricity_layer_table_colum' + (index+1) + '" scope="col" class="vertical-mid">「不會發生」</td>';
						break;
					case(this_vill_result_min == undefined && this_vill_result_max != undefined):
						predict_table_html_string["impact"] += '<td class="electricity_layer_table_colum' + (index+1) + '" scope="col" class="vertical-mid">最好情境：「不會發生」<br>最壞情境：「' + electricity_cat_mapping(this_vill_result_max.cat)["string"] +'」</td>';
						break;
					case(this_vill_result_min != undefined && this_vill_result_max != undefined):
						predict_table_html_string["impact"] += '<td class="electricity_layer_table_colum' + (index+1) + '" scope="col" class="vertical-mid">最好情境：「' + electricity_cat_mapping(this_vill_result_max.cat)["string"] + '」<br>最壞情境：「' + electricity_cat_mapping(this_vill_result_max.cat)["string"] +'」</td>';
						break;
				};
				predict_table_html_string["report_number"] += '<td class="background-black color-white" scope="col" class="vertical-mid"><h5 class="font-weight-bold mb-0">第' + (index+1) + '報</h5></td>';
				if (this_vill_result_max != undefined) {
					predict_table_column_color.push(electricity_cat_mapping(this_vill_result_max.cat)["color"]);
				} else {
					predict_table_column_color.push("#28A745");
				}
			});
			var html_string = 
				'<div class="row">'+
					'<div class="col-3">'+
						'<h4 class="font-weight-bold">一、村里基本資料</h4>'+
						'<table class="table table-bordered text-center" id="electricity_village_table_basic">'+
						  	'<tbody>'+
								'<tr>'+
									'<th scope="col">行政區</th>'+
									'<td scope="col">' + this_marker.TOWNNAME + '</td>'+
							    '</tr>'+
								'<tr>'+
									'<th scope="col">村里名</th>'+
									'<td scope="col">' + this_marker.VILLNAME + '</td>'+
							    '</tr>'+
								'<tr>'+
									'<th scope="col">總戶數</th>'+
									'<td scope="col">' + this_village_electricity_table.household_no + '戶</td>'+
							    '</tr>'+
								'<tr>'+
									'<th scope="col">總人口數</th>'+
									'<td scope="col">' + this_village_electricity_table.people_total + '人</td>'+
							    '</tr>'+
							'</tbody>'+
						'</table>'+
					'</div>'+
					'<div class="col-9">'+
						'<h4 class="font-weight-bold">二、預測情資</h4>'+
						'<table class="table table-bordered text-center color-white">'+
							'<caption class="pt-0">*嚴重性分級：1級：75~100%、2級：50~75%、3級：25~50%、4級：0~25%的戶數受影響。</caption>'+
						  	'<tbody>'+
								'<tr>'+
									'<th scope="col" class="vertical-mid background-black color-white">報數</th>'+
									predict_table_html_string["report_number"] +
							    '</tr>'+
								'<tr>'+
									'<th scope="col" class="background-black color-white">時間</th>'+
									predict_table_html_string["time"] +
							    '</tr>'+
								'<tr>'+
									'<th class="vertical-mid background-black color-white" scope="col">風力<br>預測</th>'+
									predict_table_html_string["wind"] +
							    '</tr>'+
								'<tr>'+
									'<th scope="col" class="background-black color-white">嚴重性<br>預測</th>'+
									predict_table_html_string["impact"] +
							    '</tr>'+
							'</tbody>'+
						'</table>'+
					'</div>'+
					'<div class="col-12">'+
						'<h4 class="font-weight-bold">三、脆弱點位與電桿分布</h4>'+
						'<div class="row">'+
							'<div class="col-5">'+
								'<ul class="nav nav-pills border-b-normal pb-2" id="pills-tab" role="tablist">' +
									'<li class="nav-item w-33 text-center">' +
										'<a class="nav-link active" data-toggle="pill" href="#electricity-village-hospital-info" role="tab">脆弱點位</a>' +
									'</li>' +
									'<li class="nav-item w-33 text-center">' +
										'<a class="nav-link" data-toggle="pill" href="#electricity-village-hole-info" role="tab">電線桿</a>' +
									'</li>' +
								'</ul>' +
								'<div class="tab-content">' +
									'<div class="tab-pane fade show active" id="electricity-village-hospital-info" role="tabpanel"></div>' +
									'<div class="tab-pane fade" id="electricity-village-hole-info" role="tabpanel">' + 
										'<div class="w-100" id="electricity-village-hole-info-table"></div>' +
									'</div>' +
									'<div class="tab-pane fade" id="electricity-village-report-info" role="tabpanel"></div>' +
								'</div>' +
							'</div>'+
							'<div class="col-7">'+
								'<div class="w-100 h-450" id="modal_map"></div>'+
							'</div>'+
						'</div>'+
					'</div>'+
					'<div class="col-12 mt-3" id="electricity_modal_news_part">'+
						'讀取網路情資中...' +
					'</div>'+
				'</div>';
				modal_open(html_string, '<i class="fas fa-book-open mr-2"></i>「' + this_marker.TOWNNAME + this_marker.VILLNAME + '」颱洪停電災情預報情資');

				setTimeout(function(){
					$(".electricity_layer_table_colum1").css("cssText", "background-color: " + predict_table_column_color[0] +"c7 !important;");
					$(".electricity_layer_table_colum2").css("cssText", "background-color: " + predict_table_column_color[1] +"c7 !important;");
					$(".electricity_layer_table_colum3").css("cssText", "background-color: " + predict_table_column_color[2] +"c7 !important;");

					var modal_map = new L.Map('modal_map', {
					    attributionControl: false,
					    zoom: 16,
					    zoomSnap: 1,
					    layers: L.tileLayer('https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m3!1e0!2sm!3i480190100!3m14!2szh-TW!3sUS!5e18!12m1!1e68!12m3!1e37!2m1!1ssmartmaps!12m4!1e26!2m2!1sstyles!2zcy5lOmd8cC5jOiNmZjI0MmYzZSxzLmU6bC50LnN8cC5jOiNmZjI0MmYzZSxzLmU6bC50LmZ8cC5jOiNmZjc0Njg1NSxzLnQ6MTl8cy5lOmwudC5mfHAuYzojZmZkNTk1NjMscy50OjJ8cy5lOmwudC5mfHAuYzojZmZkNTk1NjMscy50OjQwfHMuZTpnfHAuYzojZmYyNjNjM2Yscy50OjQwfHMuZTpsLnQuZnxwLmM6I2ZmNmI5YTc2LHMudDozfHMuZTpnfHAuYzojZmYzODQxNGUscy50OjN8cy5lOmcuc3xwLmM6I2ZmMjEyYTM3LHMudDozfHMuZTpsLnQuZnxwLmM6I2ZmOWNhNWIzLHMudDo0OXxzLmU6Z3xwLmM6I2ZmNzQ2ODU1LHMudDo0OXxzLmU6Zy5zfHAuYzojZmYxZjI4MzUscy50OjQ5fHMuZTpsLnQuZnxwLmM6I2ZmZjNkMTljLHMudDo0fHMuZTpnfHAuYzojZmYyZjM5NDgscy50OjY2fHMuZTpsLnQuZnxwLmM6I2ZmZDU5NTYzLHMudDo2fHMuZTpnfHAuYzojZmYxNzI2M2Mscy50OjZ8cy5lOmwudC5mfHAuYzojZmY1MTVjNmQscy50OjZ8cy5lOmwudC5zfHAuYzojZmYxNzI2M2M!4e0!5m1!5f2',{
						    maxZoom: 22,
						    opacity: 1
						})
					});

					var this_village_region = L.geoJson(this_geojson_data, {
						fill: false,
					}).addTo(modal_map);
					modal_map.fitBounds(this_village_region.getBounds());

					var vulerability_data = ajax_call(publicPath + "/cloud/geoserver/edp3/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=edp3:ntc_care_normal&outputFormat=application%2Fjson"), 
						modal_vulerability_layer = L.geoJSON(vulerability_data, {
							pointToLayer: function(feature, latlng) {
								feature.geometry.coordinates = feature.geometry.coordinates[0]
								return L.marker(latlng, {
									icon: new L.icon({
										iconUrl: 'marker_icon/vulnerable.png',
										iconAnchor:   [16, 32],
										iconSize:     [32, 32],
										popupAnchor:  [0, -20]
									})
								})
							}
					  	});
					modal_vulerability_layer.addTo(modal_map);

					var intersection_points = turf.pointsWithinPolygon(vulerability_data, this_geojson_data),
						hospital_info_html_string = "";
					if (intersection_points.features.length == 0) {
						hospital_info_html_string = '<h4 class="text-center mt-3">此村里範圍內無脆弱點位！</h4>';
					} else {
						intersection_points.features.forEach(function(feature, index){
							hospital_info_html_string +=
								'<tr>' +
									'<td>' + (index + 1) + '</td>' +
									'<td>' + feature.properties.title + '</td>' +
									'<td>' + feature.properties.townname + '</td>' +
									'<td>' + feature.properties.address + '</td>' +
									'<td>' + feature.properties.name + '</td>' +
									'<td>' + feature.properties.tel + '</td>' +
								'</tr>';
						});
						hospital_info_html_string =
							'<table class="table table-sm table-bordered table-scroll-tbody">' +
								'<thead class="thead-dark">' +
									'<tr>' +
										'<th>#</th>' +
										'<th>名稱</th>' +
										'<th>行政區</th>' +
										'<th>地址</th>' +
										'<th>管理人員</th>' +
										'<th>電話</th>' +
									'</tr>' +
								'</thead>' +
								'<tbody class="mostly-customized-scrollbar">' +
									hospital_info_html_string +
								'</tbody>' +
							'</table>';
					};
					$("#electricity_village_table_basic tbody").append(
						'<tr>'+
							'<th scope="col">脆弱點位數量</th>'+
							'<td scope="col">' + intersection_points.features.length + '處</td>'+
					    '</tr>'	
					);			

					$("#electricity-village-hospital-info").html(hospital_info_html_string);

					var this_polygon_string = "";
					var this_polygon_raw_data = this_geojson_data.geometry.coordinates[0][0];
					this_polygon_raw_data.forEach(function(element, index){
						if (index == (this_polygon_raw_data.length-1)) {
							this_polygon_string += element[0] + "%20" + element[1];
						} else {
							this_polygon_string += element[0] + "%20" + element[1] + ",%20";
						}
					});

					var electricity_map_layer
					$.ajax({
						url: publicPath + "/cloud/geoserver/edp2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=edp2:taipei_pole&cql_filter=WITHIN(the_geom,%20POLYGON((" + this_polygon_string + ")))&outputFormat=application%2Fjson",
						type: 'get',
						dataType: 'json'
					}).done(function(data) {
						electricity_map_layer = pole_modal_map(data, "all");
						electricity_map_layer.addTo(modal_map);

						var pie_data_object = {}, pie_data_array = [], sum = 0, table_html_string = "";
						data.features.forEach(function(element){
					  		if (pie_data_object[element.properties.type] == undefined) {
					  			pie_data_object[element.properties.type] = 0;
					  		};
					  		pie_data_object[element.properties.type] += 1, sum += 1;
						});

						Object.keys(pie_data_object).forEach(function(each_key){
							pie_data_array.push({
								name: each_key, 
								number: pie_data_object[each_key],
								percent: pie_data_object[each_key] / sum
							});
						});

						pie_data_array.forEach(function(element, index){
							table_html_string +=
								'<tr>' +
									'<td>' + (index+1) + '</td>' +
									'<td>' + element.name + '</td>' +
									'<td>' + (element.percent * 100).toFixed(0) + '%</td>' +
									'<td>' + element.number + '支</td>' +
								'</tr>';
						});

						$("#electricity-village-hole-info-table").html(
							'<table class="table table-bordered mt-2">' +
								'<caption class="pt-0">*註：可點擊表列進行地圖篩選</caption>' +
								'<thead class="thead-dark">' +
									'<tr>' +
										'<th>#</th>' +
										'<th>電桿類型</th>' +
										'<th>百分比</th>' +
										'<th>桿數</th>' +
									'</tr>' +
								'</thead>' +
								'<tbody class="p-cursor">' +
									table_html_string +
									'<tr>' +
										'<td colspan="3">總數</td>' +
										'<td>' + sum + '支</td>' +
									'</tr>' +
								'</tbody>' +
							'</table>'
						);

						$("#electricity-village-hole-info-table tbody").on("click", "tr", function(){
							var this_type = $(this).find("td").eq(1).html();
							modal_map.removeLayer(electricity_map_layer);
							if ($(this).find("td").eq(0).html() == "總數") {
								electricity_map_layer = pole_modal_map(data, "all");
							} else {
								electricity_map_layer = pole_modal_map(data, this_type);
							};
							electricity_map_layer.addTo(modal_map);
						});
					});

					function pole_modal_map(data, condition){
						var layer = L.geoJson(data, {
						  	pointToLayer: function(feature, latlng) {
						  		var boolean;
						  		if (condition == "all") {
						  			boolean = true;
						  		} else {
						  			boolean = (feature.properties.type == condition);
						  		};
						  		if (boolean) {
							    	return L.circleMarker(latlng, {
							      		radius: 4,
							      		fillOpacity: 1,
							      		fillColor: 'yellow',
							      		color: 'yellow',
							      		weight: 1
							    	}).bindPopup(
							    		'<div class="w-250">'+
							    			'<h4>' + feature.properties.id +'電桿</h4>' +
							    			'<h5>所屬區域：' + feature.properties.town + feature.properties.village + '</h5>' +
							    			'<h5>電桿類型：' + feature.properties.type + '</h5>' +
							    		'</div>'
							    	);
						  		}
						  	}
						});
						return layer;
					}

					var address = this_marker.TOWNNAME + this_marker.VILLNAME;
					$.ajax({
						url: publicPath + "/napi/emis/googleinfo?type=electricity&address=" + address.replace(" ", ""),
						dataType: 'json',
						headers: {
							Authorization: 'Bearer ' + jwt_token
						}
					}).done(function(data) {
						var news_string = googleSearchInfo(data)
						$("#electricity_modal_news_part").html(
							'<h4 class="font-weight-bold">四、網路情資(TOP10)</h4>'+
							'<h5 class="font-weight-bold"><i class="far fa-hand-point-right mr-2"></i><a target="_blank" href="https://www.google.com/search?q=新北市+停電+' + this_marker.TOWNNAME + "+" + this_marker.VILLNAME + '">點此處查看更多(關鍵字：新北市+停電+' + this_marker.TOWNNAME + this_marker.VILLNAME + ')</h5></a>'+
							news_string
						);
					});
				}, 2000);
		}

		var region_name_list = Object.keys(region_sta_container).sort(function(a,b){
			return region_sta_container[b]["sum"]-region_sta_container[a]["sum"];
		});
		var categories_array = {
			"cat1": [], "cat2": [], "cat3": [], "cat4": []
		};
		region_name_list.forEach(function(element){
			categories_array["cat1"].push(region_sta_container[element]["cat1"]);
			categories_array["cat2"].push(region_sta_container[element]["cat2"]);
			categories_array["cat3"].push(region_sta_container[element]["cat3"]);
			categories_array["cat4"].push(region_sta_container[element]["cat4"]);
		});
        Highcharts.chart('electricity_region_early_chart', {
            chart: {
                type: 'column'
            },
		    legend: {
		        align: 'right',
		        verticalAlign: 'top',
		        x: 0,
		        y: -10,
		        floating: true
		    },
            title: {
                text: ''
            },
            xAxis: {
                categories: region_name_list,
            labels: {
                step: 1,
                style: {
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: '14px'
                },
                useHTML: true,
                formatter: function(){
                    var string = this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2)
                    return string;
                }
            }
            },
            yAxis: {
                min: 0,
                title: {
                    text: '村里數量'
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: (Highcharts.theme && Highcharts.theme.textColor) || 'black'
                    }
                }
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}處村里</b> ({point.percentage:.0f}%)<br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false,
                        color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                    }
                },
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function () {
                                var query_condition = this.category;
                                // table_redraw(0, query_condition)
                                // map
                                var target_geojson;
                                overlay_dataset["Basic_map"].features.forEach(function(element){
                                    if (element.properties.TOWNNAME == query_condition) {
                                        target_geojson = element;
                                    }
                                });
                                if (overlay_dataset["temp_map"] != undefined) {
                                    map.removeLayer(overlay_dataset["temp_map"]);
                                }
                                overlay_dataset["temp_map"] = L.geoJson(target_geojson,{
                                     color: "#ef5285",
                                     weight: 3,
                                     fill: false,
                                     interactive: false
                                }).addTo(map);
                                map.fitBounds(overlay_dataset["temp_map"].getBounds());
                            }
                        }
                    }
                }
            },
            series: [{
                name: "1級",
                color: '#E31A1C',
                data: categories_array["cat4"]
            },{
                name: "2級",
                color: '#FC4E2A',
                data: categories_array["cat3"]
            },{
                name: "3級",
                color: '#FD8D3C',
                data: categories_array["cat2"]
            },{
                name: "4級",
                color: '#FED976',
                data: categories_array["cat1"]
            }]
        });
	}

	function electricity_cat_mapping(input){
		var result;
		switch(input){
			case 1:
				result = {
					"string": "4級",
					"value": {
						"max": 25,
						"min": 0
					},
					"color": '#FED976'
				};
				break;
			case 2:
				result = {
					"string": "3級",
					"value": {
						"max": 50,
						"min": 25
					},
					"color": '#FD8D3C'
				};
				break;
			case 3:
				result = {
					"string": "2級",
					"value": {
						"max": 75,
						"min": 50
					},
					"color": '#FC4E2A'
				};
				break;
			case 4:
				result = {
					"string": "1級",
					"value": {
						"max": 100,
						"min": 75
					},
					"color": "#E31A1C"
				};
				break;
		}
		return result;
	}
}
